<template>
  <div class="min-h-0 flex-1 overflow-auto bg-gray-50 p-4 dark:bg-slate-800">
    <ActivityTable :activities="itemActivity ?? []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheItemActivityPage',
  computed: { ...mapGetters({ itemActivity: 'item/getItemActivity' }) },
  methods: { ...mapActions({ fetch: 'item/fetchItemActivitiesByItemID' }) },
  beforeMount() {
    this.fetch({ item_id: this.$route.params.id })
  }
}
</script>
